import { s as o } from "./index825.mjs";
var r = o, t = r && !Symbol.sham && typeof Symbol.iterator == "symbol";
export {
  t as u
};
